import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const put = (id,notificationsConfig) =>
  requestsTemplates.put(mainPath, `/notifications/${id}`,notificationsConfig);
